<template>
  <v-navigation-drawer
    class="header-menu font-16 color-fff"
    :width="$vuetify.breakpoint.xsOnly ? '240' : '300'"
    v-model="drawerState"
    right
    temporary
    app
  >
    <div class="header-content-wrap">
      <div v-if="Getter_Token" class="user-section">
        <div class="justify-space-between items-center" style="margin-bottom:5px;margin-left:7px;">
          <div class="user-section-center">
            <div class="user-id-section d-flex justify-start align-center">
              <div class="img-wrap">
                <v-avatar size="30">
                  <img :src="require('@/assets/images/home/user.svg')" alt="" />
                </v-avatar>
              </div>
              <div class="user-id">
                <span>GRX{{ Getter_User_Info.id }}</span>
              </div>
            </div>
            <div class="icon-wrap" @click="navigatePush('messages')">
              <img class="cursor" :src="require('@/assets/images/home/notice.svg')" alt="" width="24" height="24" />
              <span class="sup-count" v-if="count !== undefined && count != '0'">{{ count }}</span>
            </div>
          </div>
        </div>

        <!-- <div v-if="Getter_Token" class="userInfo-lists">
          <v-list>
            <v-list-item v-for="user in userInfo" :key="user.id">
              <v-list-item-title @click="navigatePush(user.routeName)">{{ user.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </div> -->
      </div>
      <div v-if="!Getter_Token" class="btn-section">
        <v-btn @click="navigatePush('register')" class="btn btn-register btn-white" depressed>{{ $t('header.register') }}</v-btn>
        <v-btn @click="navigatePush('login')" class="btn btn-login btn-common" depressed>{{ $t('header.login') }}</v-btn>
      </div>

      <!-- Market, Exchange, Annoucenment, Help Center section -->
      <v-list class="pb-0">
        <v-list-item v-for="menu in headerMenu" :key="menu.id" ripple>
          <v-list-item-title class="cursor" @click="navigatePush(menu.routeName)">{{ menu.name }}</v-list-item-title>
        </v-list-item>
        <div class="line"></div>
      </v-list>

      <v-list v-if="Getter_Token" class="py-0">
        <v-list-group
          color="white"
          no-action
          :append-icon="'mdi-menu-down'"
          v-for="rightMenu in headerRightMenu"
          :key="rightMenu.id"
        >
          <template v-slot:activator>
            <v-list-item-title class="white--text">{{ rightMenu.name }}</v-list-item-title>
          </template>
          <v-list-item v-for="(option, i) in rightMenu.options" :key="i" @click="navigatePush(option.routeName)">
            {{ option.name }}
          </v-list-item>
        </v-list-group>
      </v-list>

      <v-list v-if="toggleVar" class="py-0">
        <v-list-group color="white" :append-icon="'mdi-menu-down'">
          <template v-slot:activator>
            <v-list-item-title>{{ currencyLabel }}</v-list-item-title>
          </template>

          <v-list-item v-for="item in currencies" :key="item.value" @click="changeCurrency(item.value)">{{
            item.label
          }}</v-list-item>
        </v-list-group>
      </v-list>

      <v-list class="py-0">
        <v-list-group color="white" :append-icon="'mdi-menu-down'">
          <template v-slot:activator>
            <v-list-item-title>{{ Getter_Lang.name }}</v-list-item-title>
          </template>

          <v-list-item v-for="item in sortList(Getter_Langs_List)" :key="item.code" @click="changeLang(item)">{{
            item.name
          }}</v-list-item>
        </v-list-group>
      </v-list>

      <div v-if="Getter_Token" class="btn-section-logout">
        <v-btn @click="logout" class="btn btn-logout btn-common" depressed>{{ $t('header.user.drop.logout') }}</v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { getterTypes } from '@/store/getter-types';
import { mutationTypes } from '@/store/mutation-types';
import { mapGetters, mapMutations } from 'vuex';
import currencyMixin from '@/components/CurrencyToggle/CurrencyMixin';
import langMixin from '@/components/LangToggle/LangMixin';
import { isLogin, logout } from '../../router/accountUnit';

export default {
  name: 'HeaderMenu',
  components: {},
  props: ['count'],
  data() {
    return {
      toggleVar: true,
      userInfoDropDown: false,
      model: true,
      // userInfo: [
      //   { id: 1, name: this.$t('header.user.drop.verification'), routeName: 'authentication' },
      //   { id: 2, name: this.$t('header.user.drop.invite'), routeName: 'invite' }
      // ],
      headerMenu: [
        { id: 1, name: this.$t('header.markets'), routeName: 'markets' },
        { id: 2, name: this.$t('header.exchange'), routeName: 'exchange' },
        { id: 3, name: this.$t('header.announcement'), routeName: 'announcement' },
        { id: 4, name: this.$t('header.helpCenter'), routeName: 'help' },
        // { id: 5, name: this.$t('STO'), routeName: 'sto-listing' }
      ],
      headerRightMenu: [
        {
          id: 1,
          name: this.$t('labels.acc.side.userCenter'),
          requireAuth: true,
          options: [
            { name: this.$t('labels.acc.side.accMgmt'), routeName: 'account-management' },
            { name: this.$t('header.user.drop.verification'), routeName: 'authentication' },
            { name: this.$t('header.user.drop.invite'), routeName: 'invite' },
            { name: this.$t('labels.acc.inboxMsg.notification'), routeName: 'messages' }
          ]
        },
        {
          id: 2,
          name: this.$t('header.assets'),
          routeName: 'markets',
          requireAuth: true,
          options: [{ name: this.$t('labels.finance.coinToCoinAcc'), routeName: 'coinToCoinAccount' }]
        },
        {
          id: 3,
          name: this.$t('header.orders'),
          routeName: 'exchange',
          requireAuth: true,
          options: [{ name: this.$t('labels.trade.coinOrders'), routeName: 'orders' }]
        }
      ]
    };
  },
  methods: {
    ...mapMutations([
      mutationTypes.SET_LANG,
      mutationTypes.SET_USERNAME,
      mutationTypes.SET_TOKEN,
      mutationTypes.SET_EXPIRETIME,
      mutationTypes.SET_LASTUPDATETIME,
      mutationTypes.SET_BURGER_MENU_STATE,
      mapMutations.SET_PARTNER_INFO,
      mapMutations.SET_AFFILIATE_PARTNER_INFO
    ]),
    navigatePush(routeName) {
      this.SET_BURGER_MENU_STATE(false);
      this.$router.push({ name: routeName });
    },
    logout() {
      logout();
      if (this.$route.name === 'home') {
        window.location.reload(true);
      } else {
        this.$router.replace({ name: 'home' });
      }
    },
    sortList(list) {
      return list.slice().sort((a, b) => (a.code > b.code ? 1 : -1));
    }
  },
  mixins: [currencyMixin, langMixin],
  computed: {
    ...mapGetters([getterTypes.Getter_Token, getterTypes.Getter_User_Info, getterTypes.Getter_Burger_Menu_State]),
    drawerState: {
      get() {
        return this.Getter_Burger_Menu_State;
      },
      set(val) {
        this.SET_BURGER_MENU_STATE(val);
      }
    }
  },
  created() {}
};
</script>

<style lang="stylus" scoped>
.icon-wrap {
  display: block;
  padding: 0 4px;
  position: absolute;
  right: 20px;
  top: 17px;
}

span.sup-count {
  min-width: 16px;
  height: 16px;
  font-size: 12px;
  border-radius: 2px;
  background: rgba(56, 92, 173, 1);
  color: white;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(40%, -40%);
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-menu {
  background-color: var(--header-color) !important;
}

.header-menu p {
  padding-top: 10px;
  padding-bottom: 16px;
  margin: 0;
}

.header-content-wrap {
  padding-bottom: 100px;
  margin-top: 60px;
}

.dropdown-link {
  display: block;
  padding: 10px 40px;
  margin: 0;
}

.user-section {
  padding: 15px 17px;
  position: relative;

  .user-section-dropdown {
    cursor: pointer;
    height: 30px;
    width: 50px;
  }

  .img-wrap {
    padding-right: 12px;
    width: 40px;
  }

  .user-id {
    max-width: 160px;
    word-break: break-all;
  }

  .user-center {
    color: #357ff4;
    font-size: 12px;
    padding-left: 35px;
  }

  .user-dropdown-link {
    display: block;
    padding: 10px 35px 5px;
    margin: 0;
    font-size: 14px;
  }
}

.user-section::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #f5f5f8;
  opacity: 0.1;
}

.fa {
  float: right;
  margin-right: 17px;
  margin-top: 5px;
  font-size: 15px;
}

.btn-section {
  display: flex;
  flex-direction: column;
  padding: 4px 20px 18px;
  position: relative;
}

.btn-section::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #f5f5f8;
  opacity: 0.1;
}

.btn-section-logout {
  display: flex;
  flex-direction: column;
  padding: 4px 20px 18px;
  position: relative;
}

.btn {
  border: none;
  border-radius: 2px;
  margin: 10px 0;
  cursor: pointer;
  padding: 10px 25px;
  font-size: 14px !important;
  letter-spacing: 0px;
}

.btn-register {
  width: 100%;
  align-self: flex-end;
  padding: 9px 25px;
  color: var(--blue);
}

.btn-login {
  width: 100%;
  align-self: flex-end;
  padding: 9px 25px;
}

.btn-download-app {
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #fff;
  color: #ffffff;
}

.line {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #f5f5f8;
  opacity: 0.1;
}

.btn-logout {
  width: 96%;
  align-self: center;
}

.userInfo-lists {
  .theme--light {
    .v-list-item {
      padding: 0px 44px;
      min-height: 36px;
    }
  }
}

.theme--light {
  .v-list-item {
    padding: 0 25px;
    color: #ffffff !important;

    &:not(.v-list-item--active) {
      &:not(.v-list-item--disabled) {
        color: #ffffff !important;
      }
    }
  }

  .v-list-group::v-deep {
    .v-list-group__header {
      padding: 0 25px;
    }

    .v-list-group__items {
      .v-list-item {
        padding: 0px 40px;
        font-size: 14px;
      }
    }

    .v-list-item__title {
      color: #ffffff;
    }
  }

  ::v-deep .v-icon {
    color: #ffffff;
  }
}

.line {
  content: '';
  position: relative;
  left: 0;
  width: 100%;
  border-top: 1px solid #f5f5f8;
  opacity: 0.1;
}

@media screen and (max-width: 599px) {
  .user-section {
    .user-id {
      max-width: 110px;
    }
  }
}
</style>
